<cwc-modal id="ctd-receive-success-dialog">
  <div class="text-center">
    <cwc-icon name="check-rounded-active-fill" size="120px" color="bright-green"></cwc-icon>
    <h1>{{'ctd.dialog.receive_success_heading' | translate}}</h1>
    <h3 [innerHTML]="'ctd.dialog.receive_success_msg' | translate: { orderCode: orderCode }"></h3>
  </div>
</cwc-modal>